// @flow
import { createSelector, type OutputSelector } from 'reselect';

import { selectOneProduct } from '@gandi/cart';

import { selectResults } from 'src/DomainRenew/modules/selectors';

import type { FullState } from 'src/types';

import type { State, ExtendedRenewableProduct } from '../types';

const selectProducts = (state: FullState): State => state.renewableProducts;

const selectResultsFQDNs: OutputSelector<
  FullState,
  void,
  Array<string>,
> = createSelector([selectResults], rawResults => Object.keys(rawResults));

export const selectOtherRenewableProducts: OutputSelector<
  FullState,
  void,
  Array<ExtendedRenewableProduct>,
> = createSelector(
  [selectProducts, selectResultsFQDNs, state => state],
  (renewables, searchResultsFQDNs, state) => {
    // exclude renewables that are already provided as search results.
    const filteredRenewables = renewables.filter(
      renewable =>
        searchResultsFQDNs.indexOf(renewable.name) < 0 ||
        searchResultsFQDNs.indexOf(renewable.meta_data.fqdn_alabel) < 0,
    );

    // augment the renewables with a `product` property
    // from the matching cart product if any
    return filteredRenewables.map(renewable => {
      const params = {
        ...(renewable.type === 'domain'
          ? { fqdn: renewable.name }
          : { identifier: renewable.id }),
      };

      const product = selectOneProduct(state, params);

      return {
        ...renewable,
        product,
      };
    });
  },
);
